import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyExistingDocApprovalHost = lazyWithRetry(
  () => import("./ExistingDocApprovalHost"),
);

const ExistingDocApprovalHost = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyExistingDocApprovalHost {...props} />;

export default ExistingDocApprovalHost;
